import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const NewsCard = ({data}) => {

    const {id, name, anons, dates} = data;
    const [start, setStart] = useState('');

    useEffect(() => {
        setStart(changeOfDate(dates.created_at));
    }, []);

    function changeOfDate(date) {
        let newDate = '';
        const months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
        const index = Number(date.slice(5, 7));
        newDate += `${date.slice(8, 10)} ${months[index - 1]} ${date.slice(11, 16)}`;
        return newDate;
    }

    return (
        <>
            <div className="announcement-card">
                <div className="announcement-card__wrap page__area">
                    <div className="announcement-card__news-container">
                        <div>
                            <Link className="announcement-card__heading title title--h4" to={`//telekarta.tv/news/${id}`}>{name}</Link>
                            <div className="announcement-card__description text text--sub">
                                <p>{anons}</p>
                            </div>
                        </div>
                        <div className="announcement-card__footer">
                            <span className="announcement-card__date">{start}</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NewsCard;